import { Link } from '@inertiajs/react'
import { Building2, Users, ArrowRight } from 'lucide-react'
import AdminLayout from '@/layouts/AdminLayout'

interface Stats {
  total_organizations: number
  active_organizations: number
  total_users: number
  active_users: number
}

interface Props {
  stats: Stats
}

function StatCard({ label, value, icon: Icon, href }: { label: string; value: number; icon: React.ComponentType<{ className?: string }>; href: string }) {
  return (
    <Link
      href={href}
      className="flex items-center gap-4 rounded-lg border p-5 hover:bg-muted/30 transition-colors cursor-pointer"
    >
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
        <Icon className="h-5 w-5 text-primary" />
      </div>
      <div className="flex-1">
        <p className="text-2xl font-semibold text-foreground">{value}</p>
        <p className="text-xs text-muted-foreground">{label}</p>
      </div>
      <ArrowRight className="h-4 w-4 text-muted-foreground" />
    </Link>
  )
}

export default function AdminDashboard({ stats }: Props) {
  return (
    <>
      <header className="flex h-14 items-center border-b px-8">
        <h1 className="text-sm font-semibold">Admin Dashboard</h1>
      </header>

      <div className="flex-1 overflow-y-auto px-8 py-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <StatCard label="Total Organizations" value={stats.total_organizations} icon={Building2} href="/admin/organizations" />
          <StatCard label="Active Organizations" value={stats.active_organizations} icon={Building2} href="/admin/organizations" />
          <StatCard label="Total Users" value={stats.total_users} icon={Users} href="/admin/users" />
          <StatCard label="Active Users" value={stats.active_users} icon={Users} href="/admin/users" />
        </div>
      </div>
    </>
  )
}

AdminDashboard.layout = (page: React.ReactNode) => (
  <AdminLayout>{page}</AdminLayout>
)
